"use strict";

exports.__esModule = true;
exports.isMobileSafari = isMobileSafari;
function isMobileSafari() {
  return (/iPad|iPhone|iPod/.test(window.navigator.platform) && /^((?!CriOS).)*Safari/.test(window.navigator.userAgent)
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/scroll-behavior/lib/utils.js
// module id = 566
// module chunks = 168707334958949